export const modelCategories = {
  rag: {
    name: 'RAG-Enabled Models',
    description: 'Models configured with Retrieval-Augmented Generation capabilities for dynamic knowledge access and real-time information retrieval.'
  },
  standard: {
    name: 'Standard Models',
    description: 'Traditional models that can be used as-is or with fine-tuning for specific tasks.'
  },
  'fine-tuned': {
    name: 'Fine-Tuned',
    description: 'These models have been trained on specific datasets to enhance performance on domain-specific tasks.'
  },
  hybrid: {
    name: 'Hybrid',
    description: 'Combining RAG capabilities with fine-tuning for both accuracy and flexibility in knowledge retrieval.'
  },
  base: {
    description: 'Pre-trained models without additional customization, ready for immediate deployment.'
  }
};

const MODELS = [
  {
    id: 'rag-mistral',
    name: 'Mistral 7B',
    provider: 'Mistral AI',
    description: 'Efficient 7.3B parameter model with Grouped-Query Attention and Sliding Window Attention',
    contextWindow: '32K',
    performance: 'High',
    cost: 'low',
    type: 'rag',
    finetuned: false
  },
  {
    id: 'rag-qwen-ft',
    name: 'Qwen2.5-14B',
    provider: 'Alibaba Cloud',
    description: '14 billion-parameter open-source model supporting multiple languages, suitable for strong language understanding and generation.',
    contextWindow: '32K',
    performance: 'Very High',
    cost: 'medium',
    type: 'rag',
    finetuned: true
  },
  {
    id: 'rag-deepseek',
    name: 'DeepSeek R1',
    provider: 'DeepSeek',
    description: 'Efficient model from Chinese startup DeepSeek rivaling proprietary models like ChatGPT in performance.',
    contextWindow: '32K',
    performance: 'High',
    cost: 'medium',
    type: 'rag',
    finetuned: false
  },
  {
    id: 'mistral-7b',
    name: 'Mistral 7B',
    provider: 'Mistral AI',
    description: 'Efficient 7.3B parameter model with Grouped-Query Attention and Sliding Window Attention',
    contextWindow: '8K',
    performance: 'Medium',
    cost: 'low',
    type: 'standard',
    finetuned: false
  },
  {
    id: 'mistral-7b-ft',
    name: 'Mistral 7B (Fine-tuned)',
    provider: 'Mistral AI',
    description: 'Domain-optimized version of Mistral 7B with enhanced task-specific performance',
    contextWindow: '8K',
    performance: 'High',
    cost: 'low',
    type: 'standard',
    finetuned: true
  },
  {
    id: 'phi3-medium',
    name: 'Phi-3 Medium',
    provider: 'Microsoft',
    description: '14B parameter model optimized for efficient resource usage',
    contextWindow: '32K',
    performance: 'High',
    cost: 'medium',
    type: 'standard',
    finetuned: false
  },
  {
    id: 'phi3-medium-ft',
    name: 'Phi-3 Medium (Fine-tuned)',
    provider: 'Microsoft',
    description: 'Fine-tuned version of Phi-3 optimized for specific domain tasks',
    contextWindow: '32K',
    performance: 'Very High',
    cost: 'medium',
    type: 'standard',
    finetuned: true
  },
  {
    id: 'gemma-12b',
    name: 'Gemma 12B',
    provider: 'Google DeepMind',
    description: '12B parameter model optimized for GPU usage with Gemini architecture',
    contextWindow: '32K',
    performance: 'High',
    cost: 'medium',
    type: 'standard',
    finetuned: false
  }
];

export const getModelsByType = (modelType, includeFinetuned = true) => {
  return MODELS.filter(model => 
    model.type === modelType && (includeFinetuned || !model.finetuned)
  );
};

export const getModelById = (modelId) => {
  return MODELS.find(model => model.id === modelId);
};

export const getPerformanceColor = (performance) => {
  switch (performance) {
    case 'Very High':
      return 'success';
    case 'High':
      return 'primary';
    case 'Medium':
      return 'info';
    case 'Low':
      return 'warning';
    default:
      return 'default';
  }
};

export const getCostDisplay = (cost) => {
  switch (cost) {
    case 'very-high':
      return { label: '$$$$', color: 'error' };
    case 'high':
      return { label: '$$$', color: 'warning' };
    case 'medium':
      return { label: '$$', color: 'info' };
    case 'low':
      return { label: '$', color: 'success' };
    default:
      return { label: '$', color: 'default' };
  }
};
